import { Hidden } from '@epilot/concorde-elements'
import type { BlockUiSchema, CONTROL_NAME } from '@epilot/journey-logic-commons'
import { clsx, getBlockClassname } from '@epilot/journey-logic-commons'
import { isLayout } from '@jsonforms/core'
import type { LayoutProps, UISchemaElement } from '@jsonforms/core'
import { JsonFormsDispatch, withJsonFormsLayoutProps } from '@jsonforms/react'

import { ID_TYPE, uuidToHtmlId } from '../../utils'
import { BlockContent, BlockHeading } from '../components'

import classes from './GroupLayout.module.scss'

type GroupOptions = {
  name: string
  title: string
  subtitle: string
  showPaper: boolean
  display: boolean
}

function GroupLayout({
  uischema,
  schema,
  enabled,
  path,
  renderers
}: LayoutProps) {
  if (!isLayout(uischema)) {
    return null
  }

  const { name, title, subtitle, showPaper } = uischema.options as GroupOptions
  const blocks = uischema.elements

  const mappedBlocks = blocks.map((block, index) => {
    const options: UISchemaElement['options'] = {
      ...block.options,
      isNested: true
    }

    block.options = options

    const blockClassname = getBlockClassname(block.type as CONTROL_NAME, block)
    const blockHTMLId = uuidToHtmlId(
      ID_TYPE.BLOCK,
      (block as BlockUiSchema)?.id
    )

    return (
      <div
        className={clsx(
          options.halfWidth ? classes.halfWidth : classes.fullWidth,
          blockClassname
        )}
        id={blockHTMLId}
        key={`${name}${index}`}
      >
        <JsonFormsDispatch
          enabled={enabled}
          path={path}
          renderers={renderers}
          schema={schema}
          uischema={block}
        />
      </div>
    )
  })

  const isVisible =
    uischema.options?.display === undefined ? true : uischema.options?.display

  return (
    <Hidden showChildren={isVisible}>
      <BlockContent isGroup showCard={showPaper}>
        <BlockHeading isGroup subtitle={subtitle} title={title}>
          <div className={classes.blocksContainer}>{mappedBlocks}</div>
        </BlockHeading>
      </BlockContent>
    </Hidden>
  )
}

export default withJsonFormsLayoutProps(GroupLayout)
